<template>
    <div>
        trucking
    </div>
</template>
<script>
export default {
    name: 'TruckingRegister'
}
</script>